export default {
    data: {
        "entitlements": [
            "sumfestbutaug",
            "sumfestbut1_claimed_ent", "sumfestbut1_completed_ent",
            "sumfestbut2_claimed_ent", "sumfestbut2_completed_ent",
            "sumfestbut3_claimed_ent", "sumfestbut3_completed_ent",
            "sumfestbut4_claimed_ent", "sumfestbut4_completed_ent",
            "sumfestbut5_claimed_ent", "sumfestbut5_completed_ent",
            "sumfestbut6_claimed_ent", "sumfestbut6_completed_ent",
            "sumfestbut7_claimed_ent", "sumfestbut7_completed_ent",
            "sumfestbut8_claimed_ent", "sumfestbut8_completed_ent",
            "sumfestbut9_claimed_ent", "sumfestbut9_completed_ent",
            "sumfestbut10_claimed_ent", "sumfestbut10_completed_ent",
            "sumfestbut11_claimed_ent", "sumfestbut11_completed_ent",
            "sumfestbut12_claimed_ent", "sumfestbut12_completed_ent",
            "sumfestbut13_claimed_ent", "sumfestbut13_completed_ent",
            "sumfestbut14_claimed_ent", "sumfestbut14_completed_ent",
            "sumfestbut15_claimed_ent", "sumfestbut15_completed_ent",
            "sumfestbut16_claimed_ent", "sumfestbut16_completed_ent",
            "sumfestbut17_claimed_ent", "sumfestbut17_completed_ent",
            "sumfestbut18_claimed_ent", "sumfestbut18_completed_ent"]
    }
};